var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{attrs:{"no-body":""}},[_c('b-form',{staticStyle:{"margin":"1.25rem"}},[_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"label":_vm.$t('simulation.values') + ' (' + _vm.$t('simulation.valuesDescription') + ')'}},[_c('b-form-input',{attrs:{"input-id":"tags-basic"},on:{"change":(value) => {
                                if (value == null || value == '') {
                                    this.objectList = '1;0;1;0;1';
                                }
                            }},model:{value:(_vm.objectList),callback:function ($$v) {_vm.objectList=$$v},expression:"objectList"}})],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }